import { Select } from 'antd';

import { GetChartsPeriodsMap } from './lib/index.jsx';

import stylesCharts from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ChartsPeriodNav = ({ t, onChangePeriod, defaultPeriod }) => {
  const ChartsPeriodsMap = GetChartsPeriodsMap(t);
  return (
    <div className={stylesCharts.statisticsPeriod}>
      {/*<Radio.Group*/}
      {/*  onChange={onChangePeriod}*/}
      {/*  defaultValue={defaultPeriod}*/}
      {/*  buttonStyle={'solid'}*/}
      {/*  className={'radio-group--bg radio-group--bg-white'}*/}
      {/*>*/}
      {/*  <Radio.Button value={ChartsPeriodsMap.week.value}>{ChartsPeriodsMap.week.label}</Radio.Button>*/}
      {/*  <Radio.Button value={ChartsPeriodsMap.month.value}>{ChartsPeriodsMap.month.label}</Radio.Button>*/}
      {/*  <Radio.Button value={ChartsPeriodsMap.quarter.value}>{ChartsPeriodsMap.quarter.label}</Radio.Button>*/}
      {/*  <Radio.Button value={ChartsPeriodsMap.year.value}>{ChartsPeriodsMap.year.label}</Radio.Button>*/}
      {/*</Radio.Group>*/}
      <Select
        defaultValue={defaultPeriod}
        onChange={onChangePeriod}
        options={[
          { value: ChartsPeriodsMap.week.value, label: ChartsPeriodsMap.week.label },
          { value: ChartsPeriodsMap.month.value, label: ChartsPeriodsMap.month.label },
          { value: ChartsPeriodsMap.quarter.value, label: ChartsPeriodsMap.quarter.label },
          { value: ChartsPeriodsMap.year.value, label: ChartsPeriodsMap.year.label },
        ]}
        suffixIcon={<CroplerIcon name="down" />}
      />
    </div>
  );
};

export default ChartsPeriodNav;
